<template>
  <div class="charge-finish-draw-gun v-service">
    <div class="finish-info">
      <div class="card-number">{{info.carNo}}</div>
      <div class="my-card">

      </div>
      <div class="charge-time">{{getTime(time) }}</div>
      <!-- <div class="mfei-time">免费--分钟</div> -->
      <div class="time-text">等待拔枪，当前正在计算占桩费用</div>
      <div class="delayed-info" @click="delayedDetails" v-if="info.delayFeePkId">
        <div class="delayed-info-flex">
          <div class="delayed-value"><span class="val">{{delayedData.freeMinutes || '--'}}</span>分钟</div>
          <div class="delayed-name">免费时长</div>
        </div>
        <div class="delayed-info-flex">
          <div class="delayed-value"><span class="val">{{delayedFee}}</span>元/分钟</div>
          <div class="delayed-name">当前延时费</div>
        </div>
        <div class="v-center">
          <img class="right-icon" src="../../../assets/image/right-icon.png" alt="">
        </div>
      </div>
    </div>
    <div class="charge-finish-base-info">
      <div class="cell">
        <div class="cell-title">停止原因</div>
        <div class="cell-content">{{info.stopReason | formatNullValue}}</div>
      </div>
    </div>
    <div class="btn-box">
      <pi-button block
                 @click="close">关闭</pi-button>
    </div>
  </div>
</template>

<script>
import {  getGunOrderStatus, getOrderDelayInfo } from "../../../common/api";

export default {
  name: "change-finish",
  components: {},
  data() {
    return {
      info: {},
      accountPkId: null,
      gunNumber: null,
      serialNumber: null,
      orderNo: null,
      timer: null,
      userInfo: {},
      time: 0,
      isDelayed: false,
      delayedData: {},
      delayedFee: '--'
    };
  },
  props: {
    propOrderNo: {
      type: String,
      default: ''
    }
  },
  mounted() {
    this.orderNo = this.propOrderNo == '' ? this.$route.query.orderNo : this.propOrderNo;
    this.getGunOrderStatus();
    this.pollUpdate();
    // this.getOrderDelayInfo();
  },
  methods: {
    delayedDetails(){
      this.$router.push('/charge/delayed-details?id=' + this.info.delayFeePkId + '&deviceType=' + this.info.deviceType)
    },
    getTime(time) {
      if(time > 0){
        let h = "00";
        let m = "00";
        let s = "00";
        if (time > 60) {
          m = parseInt(time / 60);
          s = time % 60;
          if (m > 60) {
            h = parseInt(m / 60);
            m = m % 60;
          }
        } else {
          s = time;
        }
        return this.timeZore(h) + ":" + this.timeZore(m) + ":" + this.timeZore(s);
      }else {
        return '--';
      }
    },
    timeZore(val) {
      if (typeof val == "number" && val < 10) {
        return "0" + val;
      } else {
        return val;
      }
    },
    getOrderDelayInfo(){ // this.info.delayFeePkId
      getOrderDelayInfo({delayFeePkId: this.info.delayFeePkId,deviceType: this.info.deviceType}).then((ret) => {
        if (ret.status === this.$config.ajaxStatus) {
          // 延时费信息
          let data = ret.data[0] || {};
          this.delayedData = data;
          if(data.details){
            let thisTime = this.getTimeNumber(this.$common.thisTimes('HH:MM'));
            let delayedFee = 0;
            data.details.map(item=>{
              if(thisTime >= item.beginTime && thisTime<= item.endTime){
                delayedFee = item.slotDelayPrice
              }
            })
            this.delayedFee = delayedFee;
          }
          
        }
      })
    },
    getTimeNumber(time){
      let arr = time.split(':');
      return arr[0] * 100 + parseInt(arr[1]);
    },
    getGunOrderStatus() {
      getGunOrderStatus({
        orderNo: this.orderNo,
        // gunNumber: this.gunNumber,
        // serialNumber: this.serialNumber,
      },false)
        .then((data) => {
          if (data.status === this.$config.ajaxStatus) {
            this.info = data.data[0];
            let time = 0
            if(this.info.currTime && this.info.endTime){
              time = parseInt(this.info.currTime / 1000) - parseInt(this.info.endTime / 1000);
            }
            this.time = time;
            if(this.info.delayFeePkId && this.info.delayFeePkId !='' && !this.isDelayed){
              // 请求延时费信息
              this.isDelayed = true;
              this.getOrderDelayInfo();
            }
            if (
              data.data[0].orderStatus === 5 ||
              data.data[0].orderStatus === 9
            ) {
              //充电完成，跳转到充电结束界面等待拔枪
              this.$router.replace({
                name: "order-not-pay",
                query: {
                  // accountPkId: this.accountPkId,
                  // gunNumber: this.gunNumber,
                  // serialNumber: this.serialNumber,
                  orderNo: this.orderNo,
                  replace: true
                },
              });
              
            } else if (data.data[0].orderStatus === 6) {
              // 自动结算
              this.$router.replace({
                name: "pay-success",
                query: {
                  orderNo: this.orderNo,
                  replace: true
                },
              });
            } else {
              //订单异常
              this.$common.checkOrderIsAbnormal(
                this.$router,
                data.data[0].orderStatus
              );
            }
          } else {
            throw new Error(data.msg);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    pollUpdate() {
      this.timer = setInterval(() => {
        this.refresh();
      }, this.$config.pullTimeDistance);
    },
    refresh() {
      this.getGunOrderStatus();
    },
    close() {
      this.$router.replace({
        name: "home"
      })
      // this.$router.go(-1);
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>

<style lang="less" scoped>
@primaryColor: #14cc80;

.charge-finish-draw-gun {

  .finish-info {
    background-color: #333333;
    position: relative;
    color: #fff;
    min-height: 6.5rem;
    padding-top: 0.35rem;
    box-sizing: border-box;
    text-align: center;
    .card-number {
      font-size: 0.36rem;
      line-height: 0.5rem;
    }
    .my-card {
      margin-top: 0.1rem;
      width: 3.6rem;
      height: 1.78rem;
      display: inline-block;
      background-image: url("../../../assets/image/success-car.png");
      background-size: 100% 100%;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .charge-time {
      margin-top: 0.13rem;
      font-size: 0.72rem;
      line-height: 1rem;
    }
    .mfei-time {
      margin-top: 0.1rem;
      font-size: 0.36rem;
      line-height: 0.5rem;
    }
    .time-text {
      margin-top: 0.2rem;
      font-size: 0.26rem;
      line-height: 0.37rem;
      color: #bbbbbb;
    }
  }
  .btn-box {
    margin-top: 0.4rem;
    padding: 0.2rem;
  }
  .delayed-info{
    // margin-top: 0.61rem;
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 0;
    background: rgba(255,255,255,0.05);
    border-radius: 0 0 0.1rem 0.1rem;
    display: flex;
    .delayed-info-flex{
      flex: 1;
      padding: 0.23rem 0 0.22rem 0;
      text-align: center;
    }
    .delayed-value{
      font-size: 0.26rem;
      line-height: 0.53rem;
      .val{
        font-size: 0.38rem;
      }
    }
    .delayed-name{
      font-size: 0.26rem;
      line-height: 0.37rem;
      color: #bbbbbb;
      margin-top: 0.1rem;
    }
    .right-icon{
      width: 0.16rem;
      height: 0.28rem;
      margin-right: 0.2rem;
    }
  }
}

.cell {
  position: relative;
  padding: 0.24rem 0.24rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .cell-title {
    color: #999999;
    min-width: 2rem;
  }
  .cell-content {
    color: #666666;
    flex: 1;
    width: 0;
    text-align: end;
  }
  &:after {
    position: absolute;
    left: 0.2rem;
    right: 0.2rem;
    bottom: 0;
    border-bottom: 1px solid #d9d9d9;
    opacity: 0.8;
    content: "";
  }
}

</style>
